import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ApiResponse} from '../classes/api-response';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {delay, map} from 'rxjs/operators';
import {Constants} from "../utils/constants";
import {Permission} from "../model/permission";


@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private readonly entities = Constants.entities;

  constructor(private http: HttpClient) {
  }

  public getAllPermissions(): Observable<Permission[]> {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.permissions}`)
      .pipe(map(value => value.data as Permission[]));
  }

  public getPermissionsMock(): Observable<Permission[]> {
    return of({
      data: [
        {id: 1, name: 'ADMIN', description: 'description', creationDate: new Date()},
        {id: 2, name: 'TESTER', description: 'description', creationDate: new Date()}
      ]
    }).pipe(
      delay(500),
      map(res => res.data as Permission[])
    );
  }
}
